import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import T, { Translate } from '../i18n/i18n';
import { Window, Header, HeaderTitle, ButtonBar, Button, Background, Page, Image, PageContent, PageTitle, PageText } from './Tutorial.styles';

export default (props) => {
    
    const [opened, setOpened] = useState(true);
    const [page, setPage] = useState(props.start);
    const playerId = useSelector(state => state.authState.id);

    const close = () => {
        setOpened(false);
        localStorage.setItem('hide-tutorial-' + props.id + '-' + playerId, String((new Date()).getTime()));
    }

    const nextPage = () => {
        if (page<props.end) {
            setPage(p=> p+1);
        } else {
            close();
        }
    }

    const prevPage = () => {
        setPage(p=> p>props.start ? p-1 : p);
    }

    return <>
        <Background className={opened ? 'opened' : ''} />
        <Window className={opened ? 'opened' : ''}>
            <Header>
                <HeaderTitle><T value={props.translate || "tutorial.title"}/></HeaderTitle>
            </Header>
            <Page>
                <Image src={`/app/tutorial/welcome-${page}.png`} />
                <PageContent className={"scrollbar"}>
                    <PageTitle><T value={`tutorial.title${page}`} /></PageTitle>
                    <PageText dangerouslySetInnerHTML={{__html: Translate(`tutorial.text${page}`)}}></PageText>
                </PageContent>
            </Page>
            <ButtonBar>
                <Button color={"#999"} onClick={() => {close()}}><T value="close" /></Button>
                <div style={{flex: 1}}></div>
                <Button color={"#08f"} className={page <= props.start ? 'inactive' : ''} onClick={() => {prevPage()}}><T value="tutorial.prev" /></Button>
                <Button color={"#08f"} onClick={() => {nextPage()}}><T value={page === props.end ? "close" : "tutorial.next"} /></Button>
            </ButtonBar>
        </Window>
    </>;

};